import React from 'react';
import { Link } from 'react-router-dom';

const BadGatewayPage = () => {
  return (
    <div className="error-page">
      <h1>502 Bad Gateway</h1>
      <p>The server received an invalid response from an upstream server. Please try again later.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default BadGatewayPage;
